import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    constructor() {
        super(...arguments);
        this.deferredPrompt = null;
    }
    async connect() {
        const banner = document.querySelector("#pwa-install-banner");
        const btn = banner.querySelector("#pwa-install-btn");
        const ua = navigator.userAgent.toLowerCase();
        // iOS Safari
        const isIOSSafari = (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ipod")) &&
            ua.includes("safari") &&
            !ua.includes("crios") && // Chrome iOS
            !ua.includes("fxios"); // Firefox iOS
        // macOS Safari
        const isMacSafari = ua.includes("macintosh") &&
            ua.includes("safari") &&
            !ua.includes("chrome") &&
            !ua.includes("chromium");
        const isStandalone = window.matchMedia("(display-mode: standalone)")
            .matches;
        if (!isStandalone) {
            if (isIOSSafari || isMacSafari) {
                btn.classList.add("d-none");
                if (isIOSSafari) {
                    const instructions = banner.querySelector("#ios-pwa-install-instructions");
                    instructions.classList.remove("d-none");
                }
                else if (isMacSafari) {
                    const instructions = banner.querySelector("#safari-pwa-install-instructions");
                    instructions.classList.remove("d-none");
                }
                banner.classList.remove("d-none");
            }
            window.addEventListener("beforeinstallprompt", (e) => {
                e.preventDefault();
                this.deferredPrompt = e;
                banner.classList.remove("d-none");
            });
            document.addEventListener("DOMContentLoaded", () => {
                if (!btn)
                    return;
                btn.addEventListener("click", async () => {
                    if (!this.deferredPrompt)
                        return;
                    this.deferredPrompt.prompt();
                    const choice = await this.deferredPrompt.userChoice;
                    this.deferredPrompt = null;
                    if (choice.outcome === "accepted") {
                        banner.classList.add("d-none");
                    }
                });
            });
        }
    }
}
